import React from "react";
import "./mujibur_page.scss";

const logoAsset = "/images/document-generator/header-logo.jpg";
const footerAsset = "/images/document-generator/footer-banner.jpg";

const sampleItems = [
  {
    id: 1,
    name: "Indoor camera : DH-IPC-HDW2449T-s-PV",
    quantity: "09",
    rate: "237.00",
    isTaxed: true,
    tax: "5.00",
    amount: "2133.00",
  },
  {
    id: 2,
    name: "Switch: Dahua DH-CS4226-24ET-240",
    quantity: "01",
    rate: "595.00",
    isTaxed: true,
    tax: "5.00",
    amount: "595.00",
  },
  {
    id: 3,
    name: "Camera Pool - 1 Meter",
    quantity: "02",
    rate: "70.00",
    isTaxed: true,
    tax: "5.00",
    amount: "140.00",
  },
  {
    id: 4,
    name: "Cabling: Full copper cable pulling and termination and testing labeling",
    quantity: "18",
    rate: "330.00",
    isTaxed: true,
    tax: "5.00",
    amount: "5940.00",
  },
  {
    id: 5,
    name: "Camera Back Box",
    quantity: "09",
    rate: "45.00",
    isTaxed: true,
    tax: "5.00",
    amount: "405.00",
  },
  {
    id: 6,
    name: "Camera Installation Focusing",
    quantity: "18",
    rate: "60.00",
    isTaxed: true,
    tax: "5.00",
    amount: "1080.00",
  },
];

const defaultItems = sampleItems.map((item) => ({ ...item, visible: true }));

const initialDocument = {
  documentType: "Delivery Note",
  currency: "AED",
  title: "Delivery Note",
  date: "2026-10-01",
  header: "",
  to: "AZMAT, Team Engineering Enterprises Ltd.",
  subject: "CCTV Works.",
  description:
    "Please find below a cost-breakdown for the quotation. Please consider this quotation, and do not hesitate to contact me with any questions.",
  footer: "",
  notes: [
    { text: "Prices are in U.A.E Dirham.", visible: true },
    { text: "Warranty 1 year", visible: true },
  ],
  terms:
    "A 50% advance payment is required before starting any work, with the remaining balance payable after installation.",
  name: "Rasool Mohideen",
  position: "Operations Manager",
  email: "rasool@tajalhafiz.com",
  beneficiaryName: "Taj Al Hafiz Technical and Cleaning Services LLC",
  bankName: "ADCB",
  accountNumber: "12542199820001",
  ibanNumber: "AE140030012542199820001",
};

const initialVisibility = {
  logo: true,
  header: true,
  title: true,
  date: true,
  to: true,
  subject: true,
  description: true,
  items: true,
  notes: true,
  terms: true,
  name: true,
  position: true,
  email: true,
  bank: true,
  beneficiaryName: true,
  bankName: true,
  accountNumber: true,
  ibanNumber: true,
  footer: true,
  footerImage: true,
};

const makeItem = (id) => ({
  id,
  name: "",
  quantity: "01",
  rate: "0.00",
  isTaxed: true,
  tax: "5.00",
  amount: "0.00",
  visible: true,
});

const formatMoney = (value) => Number(value || 0).toFixed(2);

const formatDate = (value) => {
  if (!value) return "";
  const parts = value.split("-");
  return parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : value;
};

const VisibilityToggle = ({ checked, onChange, label = "PDF" }) => (
  <label className="builder-visibility-toggle" title="Show this field in the PDF">
    <input type="checkbox" checked={checked} onChange={onChange} />
    <span>{label}</span>
  </label>
);

const Field = ({ label, hint, children, className = "", visible, onVisibilityChange }) => (
  <div className={`builder-field ${className}`}>
    <div className="builder-field__label-row">
      <label>{label}</label>
      <div className="builder-field__meta">
        {hint ? <span>{hint}</span> : null}
        {onVisibilityChange ? (
          <VisibilityToggle checked={visible} onChange={onVisibilityChange} />
        ) : null}
      </div>
    </div>
    {children}
  </div>
);

const TextInput = ({ className = "", ...props }) => (
  <input className={`builder-input ${className}`} {...props} />
);

const TextArea = ({ className = "", ...props }) => (
  <textarea className={`builder-input builder-textarea ${className}`} {...props} />
);

const SectionHeading = ({ number, eyebrow, title, description }) => (
  <div className="builder-section-heading">
    <span className="builder-section-heading__number">{number}</span>
    <div>
      <p>{eyebrow}</p>
      <h2>{title}</h2>
      {description ? <span>{description}</span> : null}
    </div>
  </div>
);

const ActionButton = ({ children, className = "", ...props }) => (
  <button className={`builder-action ${className}`} type="button" {...props}>
    {children}
  </button>
);

function MujiburPage() {
  const [documentData, setDocumentData] = React.useState(initialDocument);
  const [items, setItems] = React.useState(defaultItems);
  const [visibility, setVisibility] = React.useState(initialVisibility);
  const [logo, setLogo] = React.useState(logoAsset);
  const [footerImage, setFooterImage] = React.useState(footerAsset);

  const updateDocument = (key, value) => {
    setDocumentData((current) => ({ ...current, [key]: value }));
  };

  const toggleVisibility = (key) => {
    setVisibility((current) => ({ ...current, [key]: !current[key] }));
  };

  const updateItem = (id, key, value) => {
    setItems((current) =>
      current.map((item) => {
        if (item.id !== id) return item;

        const next = { ...item, [key]: value };
        if (key === "tax") {
          next.isTaxed = String(value).trim() !== "";
        }
        if (key === "quantity" || key === "rate") {
          next.amount = formatMoney(Number(next.quantity || 0) * Number(next.rate || 0));
        }
        return next;
      })
    );
  };

  const addItem = () => {
    setItems((current) => [...current, makeItem(Date.now())]);
  };

  const removeItem = (id) => {
    setItems((current) => current.filter((item) => item.id !== id));
  };

  const moveItem = (id, direction) => {
    setItems((current) => {
      const index = current.findIndex((item) => item.id === id);
      const nextIndex = index + direction;
      if (index < 0 || nextIndex < 0 || nextIndex >= current.length) return current;
      const next = [...current];
      [next[index], next[nextIndex]] = [next[nextIndex], next[index]];
      return next;
    });
  };

  const updateNote = (index, key, value) => {
    setDocumentData((current) => ({
      ...current,
      notes: current.notes.map((note, noteIndex) =>
        noteIndex === index ? { ...note, [key]: value } : note
      ),
    }));
  };

  const addNote = () => {
    setDocumentData((current) => ({
      ...current,
      notes: [...current.notes, { text: "", visible: true }],
    }));
  };

  const removeNote = (index) => {
    setDocumentData((current) => ({
      ...current,
      notes: current.notes.filter((_, noteIndex) => noteIndex !== index),
    }));
  };

  const handleImageUpload = (setImage) => (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setImage(String(reader.result));
    reader.readAsDataURL(file);
  };

  const resetDocument = () => {
    setDocumentData(initialDocument);
    setItems(defaultItems);
    setVisibility(initialVisibility);
    setLogo(logoAsset);
    setFooterImage(footerAsset);
  };

  const visibleItems = items.filter((item) => item.visible !== false);
  const subtotal = visibleItems.reduce((total, item) => total + Number(item.amount || 0), 0);
  const taxTotal = visibleItems.reduce(
    (total, item) =>
      total + (item.isTaxed ? Number(item.amount || 0) * (Number(item.tax || 0) / 100) : 0),
    0
  );
  const grandTotal = subtotal + taxTotal;
  const visibleNotes = documentData.notes.filter((note) => note.visible !== false);
  const visibleBankFields = [
    visibility.beneficiaryName,
    visibility.bankName,
    visibility.accountNumber,
    visibility.ibanNumber,
  ];
  const hasVisibleBankFields = visibility.bank && visibleBankFields.some(Boolean);
  const hasVisibleSignoff = visibility.name || visibility.position || visibility.email;

  return (
    <div className="document-builder">
      <header className="document-builder__topbar">
        <div>
          <p className="document-builder__eyebrow">Document studio / 01</p>
          <h1>Build a polished PDF in seconds.</h1>
          <p className="document-builder__intro">
            Shape an invoice or delivery note, preview every detail, then print it as an A4 PDF.
          </p>
        </div>
        <div className="document-builder__top-actions">
          <ActionButton className="builder-action--quiet" onClick={resetDocument}>
            Reset
          </ActionButton>
          <ActionButton className="builder-action--primary" onClick={() => window.print()}>
            <span className="builder-action__icon" aria-hidden="true">↗</span>
            Print / Save PDF
          </ActionButton>
        </div>
      </header>

      <div className="document-builder__workspace">
        <aside className="document-builder__editor" aria-label="Document editor">
          <section className="builder-card">
            <SectionHeading
              number="01"
              eyebrow="Document setup"
              title="Set the tone"
              description="The header logo and footer banner start with the supplied sample branding."
            />
            <div className="builder-grid builder-grid--three">
              <Field label="Document type">
                <select
                  className="builder-input"
                  value={documentData.documentType}
                  onChange={(event) => updateDocument("documentType", event.target.value)}
                >
                  <option>Delivery Note</option>
                  <option>Invoice</option>
                  <option>Quotation</option>
                  <option>Receipt</option>
                </select>
              </Field>
              <Field
                label="Date"
                visible={visibility.date}
                onVisibilityChange={() => toggleVisibility("date")}
              >
                <TextInput
                  type="date"
                  value={documentData.date}
                  onChange={(event) => updateDocument("date", event.target.value)}
                />
              </Field>
              <Field label="Currency">
                <select
                  className="builder-input"
                  value={documentData.currency}
                  onChange={(event) => updateDocument("currency", event.target.value)}
                >
                  <option value="AED">AED</option>
                  <option value="$">$</option>
                  <option value="INR">INR</option>
                </select>
              </Field>
            </div>
            <div className="builder-grid builder-grid--two">
              <Field
                label="PDF title"
                visible={visibility.title}
                onVisibilityChange={() => toggleVisibility("title")}
              >
                <TextInput
                  value={documentData.title}
                  onChange={(event) => updateDocument("title", event.target.value)}
                  placeholder="Delivery Note"
                />
              </Field>
              <Field
                label="Header text"
                hint="Optional"
                visible={visibility.header}
                onVisibilityChange={() => toggleVisibility("header")}
              >
                <TextInput
                  value={documentData.header}
                  onChange={(event) => updateDocument("header", event.target.value)}
                  placeholder="Appears below the logo"
                />
              </Field>
            </div>
            <div className="builder-grid builder-grid--two">
              <Field
                label="Header image"
                visible={visibility.logo}
                onVisibilityChange={() => toggleVisibility("logo")}
              >
                <TextInput type="file" accept="image/*" onChange={handleImageUpload(setLogo)} />
              </Field>
              <Field
                label="Footer image"
                visible={visibility.footerImage}
                onVisibilityChange={() => toggleVisibility("footerImage")}
              >
                <TextInput type="file" accept="image/*" onChange={handleImageUpload(setFooterImage)} />
              </Field>
            </div>
          </section>

          <section className="builder-card">
            <SectionHeading
              number="02"
              eyebrow="Recipient"
              title="Give it context"
              description="Use this section for the customer, subject, and opening message."
            />
            <Field
              label="To"
              visible={visibility.to}
              onVisibilityChange={() => toggleVisibility("to")}
            >
              <TextInput
                value={documentData.to}
                onChange={(event) => updateDocument("to", event.target.value)}
                placeholder="Customer or company name"
              />
            </Field>
            <Field
              label="Subject"
              visible={visibility.subject}
              onVisibilityChange={() => toggleVisibility("subject")}
            >
              <TextInput
                value={documentData.subject}
                onChange={(event) => updateDocument("subject", event.target.value)}
                placeholder="Subject of this document"
              />
            </Field>
            <Field
              label="Description"
              visible={visibility.description}
              onVisibilityChange={() => toggleVisibility("description")}
            >
              <TextArea
                rows="4"
                value={documentData.description}
                onChange={(event) => updateDocument("description", event.target.value)}
                placeholder="A short introduction for the document"
              />
            </Field>
          </section>

          <section className="builder-card builder-card--items">
            <div className="builder-section-heading builder-section-heading--items">
              <SectionHeading
                number="03"
                eyebrow="Line items"
                title="Make the numbers clear"
                description="Drag-free controls keep editing quick: change, move, duplicate, or delete any line."
              />
              <div className="builder-section-heading--items__actions">
                <VisibilityToggle
                  checked={visibility.items}
                  onChange={() => toggleVisibility("items")}
                  label="PDF"
                />
                <ActionButton className="builder-action--small" onClick={addItem}>
                  <span aria-hidden="true">+</span> Add line
                </ActionButton>
              </div>
            </div>
            <div className="item-editor" role="table" aria-label="Line items">
              <div className="item-editor__head" role="row">
                <span>Name</span>
                <span>Qty</span>
                <span>Rate</span>
                <span>Tax</span>
                <span>Amount</span>
                <span aria-label="Actions" />
              </div>
              {items.map((item, index) => (
                <div className="item-editor__row" role="row" key={item.id}>
                  <div className="item-editor__cell item-editor__cell--name" data-label="Name">
                    <TextInput
                      aria-label={`Item ${index + 1} name`}
                      value={item.name}
                      onChange={(event) => updateItem(item.id, "name", event.target.value)}
                      placeholder="Line item name"
                    />
                  </div>
                  <div className="item-editor__cell" data-label="Qty">
                    <TextInput
                      aria-label={`Item ${index + 1} quantity`}
                      type="number"
                      min="0"
                      step="1"
                      value={item.quantity}
                      onChange={(event) => updateItem(item.id, "quantity", event.target.value)}
                    />
                  </div>
                  <div className="item-editor__cell" data-label="Rate">
                    <TextInput
                      aria-label={`Item ${index + 1} rate`}
                      type="number"
                      min="0"
                      step="0.01"
                      value={item.rate}
                      onChange={(event) => updateItem(item.id, "rate", event.target.value)}
                    />
                  </div>
                  <div className="item-editor__cell item-editor__cell--tax" data-label="Tax">
                    <div className="item-editor__tax">
                      <TextInput
                        aria-label={`Item ${index + 1} tax percentage; leave empty for no tax`}
                        type="number"
                        min="0"
                        step="0.01"
                        value={item.tax}
                        placeholder="-"
                        onChange={(event) => updateItem(item.id, "tax", event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="item-editor__cell" data-label="Amount">
                    <TextInput
                      aria-label={`Item ${index + 1} amount`}
                      type="number"
                      min="0"
                      step="0.01"
                      value={item.amount}
                      onChange={(event) => updateItem(item.id, "amount", event.target.value)}
                    />
                  </div>
                  <div className="item-editor__cell item-editor__cell--actions" data-label="Action">
                    <label className="item-editor__include" title="Show this line item in the PDF">
                      <input
                        type="checkbox"
                        checked={item.visible !== false}
                        onChange={(event) => updateItem(item.id, "visible", event.target.checked)}
                      />
                      <span>PDF</span>
                    </label>
                    <div className="item-editor__actions">
                      <button type="button" onClick={() => moveItem(item.id, -1)} disabled={index === 0} aria-label="Move item up" title="Move up">↑</button>
                      <button type="button" onClick={() => moveItem(item.id, 1)} disabled={index === items.length - 1} aria-label="Move item down" title="Move down">↓</button>
                      <button type="button" className="item-editor__delete" onClick={() => removeItem(item.id)} aria-label="Delete item" title="Delete item">×</button>
                    </div>
                  </div>
                </div>
              ))}
              {!items.length ? <p className="item-editor__empty">No line items yet. Add your first one above.</p> : null}
            </div>
            <p className="builder-helper">Amount is calculated from quantity × rate, but remains editable for manual adjustments.</p>
          </section>

          <section className="builder-card">
            <SectionHeading
              number="04"
              eyebrow="Supporting details"
              title="Finish the handoff"
              description="Add notes, payment terms, sign-off details, and the bank information shown at the bottom of the sample."
            />
            <Field
              label="Notes"
              hint="Numbered list"
              visible={visibility.notes}
              onVisibilityChange={() => toggleVisibility("notes")}
            >
              <div className="notes-editor">
                {documentData.notes.map((note, index) => (
                  <div className="notes-editor__row" key={`note-${index}`}>
                    <span>{index + 1}</span>
                    <TextInput
                      aria-label={`Note ${index + 1}`}
                      value={note.text}
                      onChange={(event) => updateNote(index, "text", event.target.value)}
                      placeholder="Add a note"
                    />
                    <label className="notes-editor__visibility" title="Show this note in the PDF">
                      <input
                        type="checkbox"
                        checked={note.visible !== false}
                        onChange={(event) => updateNote(index, "visible", event.target.checked)}
                      />
                      <span>PDF</span>
                    </label>
                    <button type="button" onClick={() => removeNote(index)} aria-label="Delete note">×</button>
                  </div>
                ))}
                <ActionButton className="builder-action--link" onClick={addNote}>+ Add note</ActionButton>
              </div>
            </Field>
            <Field
              label="Terms and conditions"
              visible={visibility.terms}
              onVisibilityChange={() => toggleVisibility("terms")}
            >
              <TextArea
                rows="4"
                value={documentData.terms}
                onChange={(event) => updateDocument("terms", event.target.value)}
                placeholder="Payment terms and conditions"
              />
            </Field>
            <div className="builder-grid builder-grid--three">
              <Field
                label="Name"
                visible={visibility.name}
                onVisibilityChange={() => toggleVisibility("name")}
              >
                <TextInput value={documentData.name} onChange={(event) => updateDocument("name", event.target.value)} />
              </Field>
              <Field
                label="Position"
                visible={visibility.position}
                onVisibilityChange={() => toggleVisibility("position")}
              >
                <TextInput value={documentData.position} onChange={(event) => updateDocument("position", event.target.value)} />
              </Field>
              <Field
                label="Email"
                visible={visibility.email}
                onVisibilityChange={() => toggleVisibility("email")}
              >
                <TextInput type="email" value={documentData.email} onChange={(event) => updateDocument("email", event.target.value)} />
              </Field>
            </div>
            <div className="bank-editor">
              <p className="bank-editor__title">
                <span>Bank details</span>
                <VisibilityToggle
                  checked={visibility.bank}
                  onChange={() => toggleVisibility("bank")}
                />
              </p>
              <div className="builder-grid builder-grid--two">
                <Field
                  label="Beneficiary name"
                  visible={visibility.beneficiaryName}
                  onVisibilityChange={() => toggleVisibility("beneficiaryName")}
                >
                  <TextInput value={documentData.beneficiaryName} onChange={(event) => updateDocument("beneficiaryName", event.target.value)} />
                </Field>
                <Field
                  label="Bank name"
                  visible={visibility.bankName}
                  onVisibilityChange={() => toggleVisibility("bankName")}
                >
                  <TextInput value={documentData.bankName} onChange={(event) => updateDocument("bankName", event.target.value)} />
                </Field>
                <Field
                  label="Account number"
                  visible={visibility.accountNumber}
                  onVisibilityChange={() => toggleVisibility("accountNumber")}
                >
                  <TextInput value={documentData.accountNumber} onChange={(event) => updateDocument("accountNumber", event.target.value)} />
                </Field>
                <Field
                  label="IBAN number"
                  visible={visibility.ibanNumber}
                  onVisibilityChange={() => toggleVisibility("ibanNumber")}
                >
                  <TextInput value={documentData.ibanNumber} onChange={(event) => updateDocument("ibanNumber", event.target.value)} />
                </Field>
              </div>
            </div>
            <Field
              label="Footer text"
              hint="Optional"
              visible={visibility.footer}
              onVisibilityChange={() => toggleVisibility("footer")}
            >
              <TextArea
                rows="2"
                value={documentData.footer}
                onChange={(event) => updateDocument("footer", event.target.value)}
                placeholder="Appears above the footer image"
              />
            </Field>
          </section>
        </aside>

        <main className="document-builder__preview-area">
          <div className="preview-toolbar">
            <div>
              <span className="preview-toolbar__dot" />
              <span>Live preview</span>
            </div>
            <span>A4 / {documentData.documentType} / {documentData.currency}</span>
          </div>
          <div className="document-preview-shell">
            <article className="document-paper" aria-label="PDF preview">
              <div className="pdf-document">
                <header className="pdf-document__header">
                  {visibility.logo && logo ? <img className="pdf-document__logo" src={logo} alt="Company header" /> : null}
                  {visibility.header && documentData.header ? <p className="pdf-document__custom-header">{documentData.header}</p> : null}
                </header>

                {visibility.title || visibility.date ? (
                  <div className="pdf-document__title-row">
                    {visibility.title ? <h2>{documentData.title || documentData.documentType}</h2> : null}
                    {visibility.date ? <span>{formatDate(documentData.date)}</span> : null}
                  </div>
                ) : null}

                {visibility.to || visibility.subject || visibility.description ? (
                  <section className="pdf-document__intro">
                    {visibility.to ? (
                      <>
                        <p className="pdf-document__label">TO</p>
                        <p className="pdf-document__recipient">{documentData.to || "Recipient name"}</p>
                      </>
                    ) : null}
                    {visibility.subject ? <p className="pdf-document__subject"><strong>Subject:</strong> {documentData.subject || "-"}</p> : null}
                    {visibility.description ? <p>{documentData.description || "Add a short description for this document."}</p> : null}
                  </section>
                ) : null}

                {visibility.items ? (
                  <table className="pdf-document__table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Item</th>
                        <th>Qty</th>
                        <th>Rate ({documentData.currency})</th>
                        <th>VAT (%)</th>
                        <th>Amount ({documentData.currency})</th>
                      </tr>
                    </thead>
                    <tbody>
                      {visibleItems.length ? visibleItems.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.name || "-"}</td>
                          <td>{item.quantity || "0"}</td>
                          <td>{formatMoney(item.rate)}</td>
                          <td>{item.isTaxed ? formatMoney(item.tax) : "-"}</td>
                          <td>{formatMoney(item.amount)}</td>
                        </tr>
                      )) : (
                        <tr><td colSpan="6" className="pdf-document__empty-row">No line items included.</td></tr>
                      )}
                    </tbody>
                    <tfoot>
                      <tr><th colSpan="5">Total</th><td>{formatMoney(subtotal)} {documentData.currency}</td></tr>
                      <tr><th colSpan="5">VAT ({formatMoney(taxTotal ? (taxTotal / subtotal) * 100 : 0)}%)</th><td>{formatMoney(taxTotal)} {documentData.currency}</td></tr>
                      <tr><th colSpan="5">Grand Total</th><td>{formatMoney(grandTotal)} {documentData.currency}</td></tr>
                    </tfoot>
                  </table>
                ) : null}

                {visibility.notes ? (
                  <section className="pdf-document__notes">
                    <h3>Note:</h3>
                    {visibleNotes.length ? (
                      <ol>{visibleNotes.map((note, index) => <li key={`preview-note-${index}`}>{note.text || "-"}</li>)}</ol>
                    ) : <p>-</p>}
                  </section>
                ) : null}

                {visibility.terms ? (
                  <section className="pdf-document__terms">
                    <h3>Payment Terms &amp; Conditions:</h3>
                    <p>{documentData.terms || "-"}</p>
                  </section>
                ) : null}

                {hasVisibleSignoff ? (
                  <section className="pdf-document__signoff">
                    <p>Thanks &amp; Regards,</p>
                    {visibility.name ? <p className="pdf-document__signoff-name">{documentData.name || "-"}</p> : null}
                    {visibility.position ? <p className="pdf-document__signoff-position">{documentData.position || "-"}</p> : null}
                    {visibility.email ? <p>Email: <a href={`mailto:${documentData.email}`}>{documentData.email || "-"}</a></p> : null}
                  </section>
                ) : null}

                {hasVisibleBankFields ? (
                  <section className="pdf-document__bank">
                    <h3>Account Details:</h3>
                    <table>
                      <tbody>
                        {visibility.beneficiaryName ? <tr><td>Beneficiary Name</td><td>{documentData.beneficiaryName || "-"}</td></tr> : null}
                        {visibility.bankName ? <tr><td>Bank Name</td><td>{documentData.bankName || "-"}</td></tr> : null}
                        {visibility.accountNumber ? <tr><td>Account Number</td><td>{documentData.accountNumber || "-"}</td></tr> : null}
                        {visibility.ibanNumber ? <tr><td>IBAN Number</td><td>{documentData.ibanNumber || "-"}</td></tr> : null}
                      </tbody>
                    </table>
                  </section>
                ) : null}

                {(visibility.footer && documentData.footer) || (visibility.footerImage && footerImage) ? (
                  <footer className="pdf-document__footer">
                    {visibility.footer && documentData.footer ? <p>{documentData.footer}</p> : null}
                    {visibility.footerImage && footerImage ? <img src={footerImage} alt="Company footer contact details" /> : null}
                  </footer>
                ) : null}
              </div>
            </article>
          </div>
        </main>
      </div>
    </div>
  );
}

export default MujiburPage;
